// extracted by mini-css-extract-plugin
var _1 = "cash-fB7Cl";
var _2 = "login-ZTufg";
var _3 = "switch-qIzEi";
var _4 = "text-kNyiz";
export { _1 as "cash", _2 as "login", _3 as "switch", _4 as "text" }
